import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './TabButton.scss';
import classNames from 'classnames';

export default class TabButton extends Component {
    static propTypes = {
        label: PropTypes.string,
        active: PropTypes.bool,
        onClick: PropTypes.func
    };

    render() {
        const {label, active, onClick} = this.props;
        const buttonClassName = classNames(styles.tabButton, {
            [styles.selected]: active
        });

        return (
            <div className={buttonClassName}
                 onClick={onClick}>

                <span className={styles.label}>{label}</span>

                <div className={styles.underline}></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/controls/TabButton.js